// extracted by mini-css-extract-plugin
module.exports = {"stopWraper":"StopGame_stopWraper__30mfM","correct":"StopGame_correct__3A0C-","wrong":"StopGame_wrong__2AB7A","wraper":"StopGame_wraper__2ToUd","close":"StopGame_close__luCLs"};